import { ref, shallowReactive } from '@vue/composition-api';
import type { VueConstructor } from 'vue';

/**
 * サービスタイプの定義に必要なお決まりの状態を定義するcomposables。
 * @returns
 */
export default function useHelp(helpComponent?: VueConstructor) {
  /**
   * サービスタイプに紐づくヘルプが表示された状態かどうか。
   * これはAppViewから参照され、ヘルプコンポーネントの描画を制御するのに使用される。
   */
  const helpVisibility = ref(false);
  /**
   * ヘルプを表示するためのアクション。
   * コンテキストで流し込み、画面はこれを叩くことでヘルプが表示されるよう実装する。
   */
  const showHelp = () => {
    if (helpComponent) {
      helpVisibility.value = true;
    }
  };
  /**
   * ヘルプを隠すためのアクション。
   * 普通はヘルプ画面内からヘルプの表示を終わらせるのに使用する。
   */
  const hideHelp = () => {
    helpVisibility.value = false;
  };

  // shallowReactiveにすると、ネストした階層のreactive要素の再編成が行われなくなる。
  // 通常、reactiveのプロパティにrefが存在する場合、refは展開されてしまうが、展開させたくないためshallowReactiveで囲っている。
  return shallowReactive({
    helpComponent,
    helpVisibility,
    showHelp,
    hideHelp,
  });
}
